import React from 'react';

function StateActive() {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 9.26758C0 4.29702 4.02944 0.267578 9 0.267578C13.9706 0.267578 18 4.29702 18 9.26758C18 14.2381 13.9706 18.2676 9 18.2676C4.02944 18.2676 0 14.2381 0 9.26758Z"
        fill="#FFA66D"
        fillOpacity="0.3"
      />
      <path
        d="M5.9375 9.04883C5.9375 8.80725 6.13342 8.61133 6.375 8.61133H11.625C11.8666 8.61133 12.0625 8.80725 12.0625 9.04883V9.48633C12.0625 9.72791 11.8666 9.92383 11.625 9.92383H6.375C6.13342 9.92383 5.9375 9.72791 5.9375 9.48633V9.04883Z"
        fill="#FFA66D"
      />
    </svg>
  );
}

export default StateActive;
